import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';

const SunrisingCoursesProgram = () => {
  return (
    <div className="py-10 mb-32 bg-white">
      <div className="px-4 mx-auto max-w-7xl">
        <h2 className="mb-10 text-3xl font-bold text-center text-brown-700">
          Sunrising Courses Program
        </h2>

        {/* Card Container */}
        <div className="flex flex-wrap justify-center gap-8">
          {[
            {
              title: 'Crash & Weekend Courses (6/12 Days)',
              features: [
                'Quick Skill-Based Training',
                'Weekend Flexible Batches',
                'Hands-on Practical Sessions',
                'Basic Industry Exposure',
                'Certificate of Participation',
              ],
            },
            {
              title: '1 Month Introduction Course',
              features: [
                'Fundamental Concepts of Industry',
                'Practical Learning Approach',
                'Basic Projects & Assignments',
                'Mentor Guidance',
                'Ideal for Beginners',
              ],
            },
            {
              title: '3 Month Certification Course',
              features: [
                'Industry-Oriented Training',
                'Live Project Experience',
                'Skill Development Workshops',
                'Internship Assistance',
                'Professional Certification',
              ],
            },
            {
              title: '5+1 Month Advanced Certification',
              features: [
                'Advanced Industry Training',
                'Multiple Live Projects',
                'Mentorship by Experts',
                'Placement Assistance',
                'Portfolio Development',
              ],
            },
          ].map((program, index) => (
            <div
              key={index}
              className="flex flex-col items-start w-full max-w-sm p-6 bg-white border-b-4 shadow-lg rounded-xl border-b-orange-900"
            >
              <h3 className="w-full mb-4 text-lg font-bold text-center text-brown-700">
                {program.title}
              </h3>
              <ul className="space-y-2 text-sm text-gray-700">
                {program.features.map((item, i) => (
                  <li key={i} className="flex items-start space-x-2">
                    <BsArrowRight className="mt-1 text-orange-700" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-16 text-center">
          <Link
            to="/admission"
            className="inline-block px-8 py-3 text-white transition duration-200 bg-orange-800 rounded-full hover:bg-orange-600"
          >
            Admission Open
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SunrisingCoursesProgram;